import { render, staticRenderFns } from "./TableRelations.vue?vue&type=template&id=e053b8e8&scoped=true"
import script from "./TableRelations.vue?vue&type=script&lang=js"
export * from "./TableRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e053b8e8",
  null
  
)

export default component.exports